export function saveCredentialsToSession(tokens){
    sessionStorage.setItem("refresh-token",tokens.refreshToken)
    sessionStorage.setItem("access-token",tokens.accessToken)
    sessionStorage.setItem("email", tokens.email);
    sessionStorage.setItem("username", tokens.email);
}